const revealEls = qsa(".reveal")

if (revealEls) {
  window.addEventListener('DOMContentLoaded', () => {
    revealEls.forEach((el) => {
      const reversible = el.getAttribute("data-reversible")
      const dataThreshold = el.getAttribute("data-threshold")
      const dataTriggerPoint = el.getAttribute("data-triggerPoint")
      const threshold = parseFloat(dataThreshold) || 0
      const triggerPoint = parseFloat(dataTriggerPoint) || 0
      const rootMargin = `0px 0px -${triggerPoint * 100}% 0px`
  
      const observer = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            requestAnimationFrame(() => el.classList.add("is-visible"))
            if(!reversible){
              observer.disconnect()
  
            }
          } else {
            if(reversible){
              requestAnimationFrame(() => el.classList.remove("is-visible"))
            }
          }
        },
        { threshold, rootMargin }
      )
      observer.observe(el)
    })
  })
}
